var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgJobError = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "job-error-a",
    d: "M9,0a9,9,0,1,0,9,9A9,9,0,0,0,9,0ZM1.125,9A7.864,7.864,0,0,1,14.149,3.055L3.055,14.149A7.832,7.832,0,0,1,1.125,9ZM9,16.875a7.832,7.832,0,0,1-5.149-1.93L14.945,3.851A7.864,7.864,0,0,1,9,16.875Z",
    fill: "#ed7000"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgJobError);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/job-error.f53fbc24d211b65a2970352d532dc256.svg";